import moment from "moment";

function getFirstMonthOfTheYear(): string {
    return moment().startOf('year').format('YYYY-MM')
}

export default getFirstMonthOfTheYear